import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnforcementService } from '../shared/enforcement/enforcement.service';
import { EnforcementStatus } from '../shared/enforcement/enforcement.types';

@Component({
  selector: 'ngx-locked',
  templateUrl: './locked.component.html',
  styleUrls: ['./locked.component.scss'],
})
export class LockedComponent implements OnInit {
  loading = true;
  checking = false;
  status?: EnforcementStatus;

  constructor(
    private enforcementService: EnforcementService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // The chrome-less /locked route doesn't mount <nb-layout>, which is what
    // normally removes the index.html splash spinner (#nb-global-spinner).
    // Remove it here so it doesn't cover the locked card.
    document.getElementById('nb-global-spinner')?.remove();
    this.fetch(true);
  }

  recheck(): void {
    this.fetch(false);
  }

  openRequest(requestId: number): void {
    this.router.navigate(['/pages/visa-requests', requestId]);
  }

  logout(): void {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_app_token');
    this.router.navigateByUrl('/auth/login');
  }

  private fetch(initial: boolean): void {
    if (initial) {
      this.loading = true;
    } else {
      this.checking = true;
    }

    this.enforcementService.getStatus().subscribe({
      next: (status) => {
        this.status = status;
        this.loading = false;
        this.checking = false;
        // No longer locked (e.g. an admin released them) → return to the app.
        if (!status?.locked) {
          this.router.navigate(['/pages/home']);
        }
      },
      error: () => {
        this.loading = false;
        this.checking = false;
      },
    });
  }
}
